import React from 'react';
import { IDashboardApplicationItem, DashboardLoansToClose } from '@apply/api/src/api/ApplyApi';
import { NewApplicationPanel } from './components/NewApplicationPanel';
import { ApplyDraftPanel } from './components/ApplyDraftPanel';
import { ApplyPendingApprovalPanel } from './components/ApplyPendingApprovalPanel';
import { LoansApprovedToClosePanel } from './components/LoansApprovedToClosePanel';
import { LoanDrawPanel } from '../../components/LoanDrawPanel/LoanDrawPanel';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';

interface IDashboardParameters {
    inProgressApplications: IDashboardApplicationItem[];
    applicationsPendingApproval: IDashboardApplicationItem[];
    loansReadyToClose: DashboardLoansToClose[][];
    deleteApplication: (applicationId: number) => void;
    dashboardDrawBudgets: IDashboardDrawBudget[] | undefined;
    loading: boolean;
}

export const Dashboard: React.FC<IDashboardParameters> = ({
    inProgressApplications,
    applicationsPendingApproval,
    loansReadyToClose,
    deleteApplication,
    dashboardDrawBudgets,
    loading,
}) => {
    return (
        <div className='content'>
            <div className='contentSection half'>
                <NewApplicationPanel />
                <ApplyDraftPanel
                    applications={inProgressApplications}
                    deleteApplication={deleteApplication}
                />
                <ApplyPendingApprovalPanel applications={applicationsPendingApproval} />
            </div>
            <div className='contentSection half'>
                <LoansApprovedToClosePanel loansReadyToClose={loansReadyToClose} />
                <LoanDrawPanel
                    dashboardDrawBudgets={dashboardDrawBudgets}
                    loading={loading}
                />
            </div>
        </div>
    );
};
